import { render, staticRenderFns } from "./ApprovalFlowStatus.vue?vue&type=template&id=54586d4c&"
import script from "./ApprovalFlowStatus.vue?vue&type=script&lang=js&"
export * from "./ApprovalFlowStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54586d4c')) {
      api.createRecord('54586d4c', component.options)
    } else {
      api.reload('54586d4c', component.options)
    }
    module.hot.accept("./ApprovalFlowStatus.vue?vue&type=template&id=54586d4c&", function () {
      api.rerender('54586d4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/security/approval-flow-transaction/components/ApprovalFlowStatus.vue"
export default component.exports